// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-choose-match-clip-modal__container{
    position: relative;
}

.profile-choose-match-clip-modal__filters{
    display: flex;
    margin: 18px 32px;

}
.profile-choose-match-clip-modal__matches-container{
    margin: 0 64px;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.profile-choose-match-clip-modal__tournaments-blocked-message{
    display: flex;
    align-items: center;
    background: var(--white-color);
    padding: 16px;
    border-top: 1px solid var(--new-gray-background-color); 
    position: relative;
    bottom: 0;
    width: -webkit-fill-available;

}

.profile-choose-match-clip-modal__blocked-message.baloa-names{
    display: flex;
    align-items: center;
    color: var(--primary-very-dark-color);
    background: var(--new-informative-banner-bg-color);
    padding: 14px 8px;
    border-radius: 4px;
    width: 100%;
}

.profile-choose-match-clip-modal__blocked-message .hubicon-info::before, .profile-choose-match-clip-modal__tournaments-blocked-message .hubicon-info::before{
    font-size: 24px;
    color: var(--new-informative-banner-color);
    margin-right: 6px;
}

.profile-choose-match-clip-modal__blocked-message__button.small{
    padding: 8px 12px;
    margin-left: auto;
}

.profile-choose-match-clip-modal__table-body__container{
    border-bottom: 1px solid var(--new-gray-background-color); 
    padding: 12px 0;
    cursor: pointer;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .profile-choose-match-clip-modal .modal2__container {
        width: 100%;
        height: 100%;
        margin: 0;
        border-radius: 0px;
        max-height: none;
    }
    .profile-choose-match-clip-modal__matches-container{
        margin: 0 5px;
    }

    .profile-choose-match-clip-modal__tournaments-blocked-message{
        position: absolute;
    }

    .profile-add-video__tournament_info .baloa-table{
        width: 150px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-choose-match-clip-modal/ProfileChooseMatchClipModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,iBAAiB;;AAErB;AACA;IACI,cAAc;IACd,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,sDAAsD;IACtD,kBAAkB;IAClB,SAAS;IACT,6BAA6B;;AAEjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,kDAAkD;IAClD,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,0CAA0C;IAC1C,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,yDAAyD;IACzD,eAAe;IACf,eAAe;AACnB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,WAAW;QACX,YAAY;QACZ,SAAS;QACT,kBAAkB;QAClB,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".profile-choose-match-clip-modal__container{\n    position: relative;\n}\n\n.profile-choose-match-clip-modal__filters{\n    display: flex;\n    margin: 18px 32px;\n\n}\n.profile-choose-match-clip-modal__matches-container{\n    margin: 0 64px;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.profile-choose-match-clip-modal__tournaments-blocked-message{\n    display: flex;\n    align-items: center;\n    background: var(--white-color);\n    padding: 16px;\n    border-top: 1px solid var(--new-gray-background-color); \n    position: relative;\n    bottom: 0;\n    width: -webkit-fill-available;\n\n}\n\n.profile-choose-match-clip-modal__blocked-message.baloa-names{\n    display: flex;\n    align-items: center;\n    color: var(--primary-very-dark-color);\n    background: var(--new-informative-banner-bg-color);\n    padding: 14px 8px;\n    border-radius: 4px;\n    width: 100%;\n}\n\n.profile-choose-match-clip-modal__blocked-message .hubicon-info::before, .profile-choose-match-clip-modal__tournaments-blocked-message .hubicon-info::before{\n    font-size: 24px;\n    color: var(--new-informative-banner-color);\n    margin-right: 6px;\n}\n\n.profile-choose-match-clip-modal__blocked-message__button.small{\n    padding: 8px 12px;\n    margin-left: auto;\n}\n\n.profile-choose-match-clip-modal__table-body__container{\n    border-bottom: 1px solid var(--new-gray-background-color); \n    padding: 12px 0;\n    cursor: pointer;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .profile-choose-match-clip-modal .modal2__container {\n        width: 100%;\n        height: 100%;\n        margin: 0;\n        border-radius: 0px;\n        max-height: none;\n    }\n    .profile-choose-match-clip-modal__matches-container{\n        margin: 0 5px;\n    }\n\n    .profile-choose-match-clip-modal__tournaments-blocked-message{\n        position: absolute;\n    }\n\n    .profile-add-video__tournament_info .baloa-table{\n        width: 150px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
